<template>
    
    <v-dialog persistent v-model="getDialog" max-width="900">
      <v-card>
        <v-card-title class="headline">File Browser</v-card-title>

        <v-card-text class="file_browser">
           <file-browser 
           :axiosConfig="{baseURL: s3api}" 
           :storage="'s3'"
           :tree="false"
           @selectIcon="selectIcon"
           />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="darken-1"
            text
            @click.prevent="close()">
            close
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
 
<script>
import FileBrowser from "@/components/vuetify-file-browser";
import conf from "@/config/config";
 
export default {
    name:'S3FileBrowser',
    data() {
      return {
         s3api: conf.s3api
      }
    },
    props: {
      dialog: {
        type: Boolean
      }
    },
    computed: {
      getDialog(){
        return this.dialog;
      }
    },
    components: {
        FileBrowser
    }, 
    methods: {
      close() {
        this.$emit('closeDialog', false);
      },
      selectIcon(path) {                
        this.$emit("selectIcon", conf.s3url + path);
      }   
    } 
};
</script> 
<style lang="scss" scoped>
.headline{
    font-size: 12pt !important;
    color: #056e97;
    font-weight: bold;
    padding-bottom: 0;
}
</style>
<style lang="scss">
.file_browser {
  .py-2 {
    text-align: left;
  }
  .v-treeview-node__content{
    text-align: left;
  }
}
</style>